module.exports = __webpack_public_path__ + "img/logo_lt.2fcff234.png";